// import React, { useEffect, useState, useRef } from 'react';
// import { Button, Modal } from 'antd';
// import {
//   CREATE_USER_PANCARD_VERIFY,
//   MOBILE_SEND_VERFIY,
//   MOBILE_VERFIY_SEND,
//   USER_ROLE,
//   CREATE_ALL_TYPE_USERS,
//   CREATE_USER_AADHARCARD_VERIFY,
//   CREATE_USER_AADHARCARD_OTP_VERIFY,
//   DIGILOCKER_VERIFY,
//   CREATE_DIGILOCKER_URL,
//   GET_VERIFICATION_STATUS,
//   GET_DOCUMENT_DATA,
// } from './../../Utils/appConstants';
// import { getRequest, postRequest } from './../../Utils/AppApi';
// import { getUser, isNumber } from './../../Utils/Common';
// import { useHistory } from 'react-router-dom';
// import { ToastContainer, toast } from 'react-toastify';
// import RiseLoader from 'react-spinners/RiseLoader';
// import Select from 'react-select';

// const userData = getUser();

// function CreateUser(props) {
//   // refs for plain inputs only
//   const mobileNumberRef = useRef(null);
//   const otpNumberRef = useRef(null);
//   const otpAadharNumberRef = useRef(null);
//   const outletNameRef = useRef(null);
//   const emailRef = useRef(null);
//   const pancardNumberRef = useRef(null);
//   const aadharNumberRef = useRef(null);

//   const history = useHistory();

//   // Form data state
//   const [isData, setData] = useState({
//     userRole: '',
//     outletName: '',
//     email: '',
//     aadhar_num: '',
//     pan_num: '',
//     mobileNumber: '',
//     OtpNumber: '',
//     OtpAadharNumber: ''
//   });

//   const [fullName, setFullName] = useState('');
//   const [username, setUsername] = useState('');
//   const [password, setPassword] = useState('');
//   const [firstName, setFirstName] = useState('');
//   const [lastName, setLastName] = useState('');
//   const [pancardData, setPancardData] = useState('');
//   const [isOtpNumber, setOtpNumber] = useState(false);
//   const [roleId, setRoleId] = useState(userData?.data?.role?.code);
//   const [userOrder, setUserOrder] = useState(userData?.data?.role?.order);
//   const [isMobileNumberVerify, setMobileNumberVerify] = useState(false);
//   const [isPanNumberVerify, setPanNumberVerify] = useState(false);
//   const [isStaff, setStaff] = useState(false);
//   const [isLoading, setLoading] = useState(false);
//   const [showingSubmitPopup, setShowingSubmitPopup] = useState(false);

//   const [getRoleData, setRoleData] = useState([]);

//   const [isAadharNumberVerify, setAadharNumberVerify] = useState(false);
//   const [aadharData, setAadharData] = useState('');
//   const [isOtpAadharNumber, setOtpAadharNumber] = useState(false);

//   const [isOutletNameSubmit, setOutletNameSubmit] = useState(false);
//   const [isEmailAddressSubmit, setEmailAddressSubmit] = useState(false);
//   const [verificationId, setVerificationId] = useState(null);
//   const [referenceId, setReferenceId] = useState(null);

//   // Store the actual values that will be used in verification
//   const [pancardNumber, setPancardNumber] = useState('');
//   const [aadharNumber, setAadharNumber] = useState('');

//   const verificationIdRef = useRef(null);
//   const referenceIdRef = useRef(null);

//   const clearFormField = () => {
//     // Reset all form state
//     setData({
//       userRole: '',
//       outletName: '',
//       email: '',
//       aadhar_num: '',
//       pan_num: '',
//       mobileNumber: '',
//       OtpNumber: '',
//       OtpAadharNumber: ''
//     });
//     setAadharNumber('');
//     setPancardNumber('');
//     setFullName('');
//     setFirstName('');
//     setLastName('');
//     setPancardData('');
//     setAadharData('');
//     setOtpNumber(false);
//     setMobileNumberVerify(false);
//     setPanNumberVerify(false);
//     setAadharNumberVerify(false);
//     setOtpAadharNumber(false);
//     setOutletNameSubmit(false);
//     setEmailAddressSubmit(false);

//     verificationIdRef.current = null;
//     referenceIdRef.current = null;
//     setVerificationId(null);
//     setReferenceId(null);

//     // Clear refs
//     if (mobileNumberRef.current) mobileNumberRef.current.value = '';
//     if (otpNumberRef.current) otpNumberRef.current.value = '';
//     if (otpAadharNumberRef.current) otpAadharNumberRef.current.value = '';
//     if (outletNameRef.current) outletNameRef.current.value = '';
//     if (emailRef.current) emailRef.current.value = '';
//     if (pancardNumberRef.current) pancardNumberRef.current.value = '';
//     if (aadharNumberRef.current) aadharNumberRef.current.value = '';
//   };

//   const handleGetRoles = () => {
//     const userOrderId = userData?.data?.role?.order;
//     getRequest(`${USER_ROLE}/${userOrderId}`, history)
//       .then((response) => {
//         if (response.success === true && Array.isArray(response.data)) {
//           setRoleData(
//             response.data
//               .filter((items) => items.code !== 'V')
//               .map((item) => ({ value: item.code, label: item.name }))
//           );
//         } else {
//           toast.error(response.message || 'Failed to load roles');
//         }
//       })
//       .catch((error) => {
//         console.error('Error loading roles', error);
//         toast.error('Failed to load roles');
//       });
//   };

//   const FormValidate = () => {
//     // basic validation - ensure role present for the specific user orders
//     if ([5, 4, 2].includes(userOrder)) {
//       if (!isData || Object.keys(isData).length === 0) {
//         toast.error('Role is required');
//         return false;
//       }
//       if (!isData.userRole) {
//         toast.error('Role is required');
//         return false;
//       }
//     }

//     return true;
//   };

//   const handleVerifyMobileNumber = () => {
//     if (!FormValidate()) return;

//     if (!isData.outletName || isData.outletName.trim() === '') {
//       toast.error('Please enter Outlet Name');
//       return;
//     }

//     if (!isData.email || isData.email.trim() === '') {
//       toast.error('Please enter Email Address');
//       return;
//     }

//     const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
//     if (!emailPattern.test(isData.email)) {
//       toast.error('Please enter a valid Email Address');
//       return;
//     }

//     if (!isData.aadhar_num || isData.aadhar_num.trim() === '') {
//       toast.error('Please enter Aadhaar Number');
//       return;
//     }

//     const aadhaarRegex = /^\d{12}$/;
//     if (!aadhaarRegex.test(isData.aadhar_num.trim())) {
//       toast.error('Please enter a valid 12-digit Aadhaar Number');
//       return;
//     }

//     if (!isData.pan_num || isData.pan_num.trim() === '') {
//       toast.error('Please enter PAN Number');
//       return;
//     }

//     const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
//     if (!panRegex.test(isData.pan_num.trim().toUpperCase())) {
//       toast.error('Please enter a valid PAN Number (e.g., ABCDE1234F)');
//       return;
//     }

//     if (!isData.mobileNumber || !/^\d{10}$/.test(isData.mobileNumber)) {
//       toast.error('Please enter a valid 10-digit mobile number');
//       return;
//     }

//     setLoading(true);
//     const payload = {
//       mobile: isData.mobileNumber,
//       roleId: isData.userRole,
//     };

//     // CRITICAL: Store the values in dedicated state before proceeding
//     setAadharNumber(isData.aadhar_num.trim());
//     setPancardNumber(isData.pan_num.trim().toUpperCase());

//     console.log('Storing Aadhaar for verification:', isData.aadhar_num.trim());

//     postRequest(MOBILE_VERFIY_SEND, payload, history)
//       .then((response) => {
//         if (response.success === true) {
//           toast.success(response.message);
//           setOtpNumber(true);
//         } else {
//           toast.error(response.message || 'Failed to send OTP');
//         }
//       })
//       .catch((error) => {
//         console.error('send mobile verify error', error);
//         toast.error('Failed to send OTP');
//       })
//       .finally(() => setLoading(false));
//   };

//   const handleVerifyOtpMobileNumber = () => {
//     if (!isData.mobileNumber || !isData.OtpNumber) {
//       toast.error('Mobile and OTP are required');
//       return;
//     }

//     // Use the stored Aadhaar number from state
//     if (!aadharNumber) {
//       toast.error('Aadhaar number is required for verification');
//       return;
//     }

//     console.log('Starting OTP verification with Aadhaar:', aadharNumber);

//     setLoading(true);
//     const payload = {
//       mobile: isData.mobileNumber,
//       otp: isData.OtpNumber,
//     };

//     postRequest(MOBILE_SEND_VERFIY, payload, history)
//       .then((response) => {
//         if (response.success === true) {
//           toast.success(response.message);
//           setOtpNumber(false);
//           setMobileNumberVerify(true);
//           setOutletNameSubmit(true);
//           setEmailAddressSubmit(true);

//           // Start digilocker flow with the stored Aadhaar number
//           initiateDigilocker(isData.mobileNumber);
//         } else {
//           toast.error(response.message || 'OTP verification failed');
//         }
//       })
//       .catch((error) => {
//         console.error('OTP verify error', error);
//         toast.error('OTP verification failed');
//       })
//       .finally(() => setLoading(false));
//   };

//   const pancardValidation = (text) => {
//     if (!text) return false;
//     const regex = /^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/;
//     return regex.test(text.trim());
//   };

//   const VerifyPanNumber = (pancard) => {
//     if (!pancard) {
//       toast.error('Pancard is required');
//       return false;
//     }
//     const pc = pancard.toUpperCase().trim();
//     if (pancardValidation(pc)) {
//       return true;
//     }
//     toast.error('Pancard number is invalid');
//     return false;
//   };

//   const initiateDigilocker = (mobileNumber) => {
//     if (!FormValidate()) {
//       toast.error('Form validation failed');
//       return;
//     }

//     if (!mobileNumber || !/^\d{10}$/.test(mobileNumber)) {
//       toast.error('Please provide a valid 10-digit mobile number');
//       return;
//     }

//     setLoading(true);
//     const payload = {
//       mobile: mobileNumber,
//       type: 'onboarding',
//     };

//     console.log('Initiating DigiLocker with mobile:', mobileNumber);

//     postRequest(DIGILOCKER_VERIFY, payload, history)
//       .then((response) => {
//         console.log('DigiLocker Response:', response);
//         if (response.success === true) {
//           const verification_id = response.data?.verification_id;
//           if (verification_id) {
//             createDigilockerURL(verification_id);
//           } else {
//             toast.error('Missing verification id from DigiLocker response');
//           }
//         } else {
//           toast.error(response.message || 'Failed to initiate DigiLocker');
//         }
//       })
//       .catch((error) => {
//         console.error('DigiLocker Error:', error);
//         toast.error('Failed to initiate DigiLocker verification');
//       })
//       .finally(() => setLoading(false));
//   };

//   const createDigilockerURL = (verification_id) => {
//     if (!FormValidate()) {
//       toast.error('Form validation failed');
//       return;
//     }

//     setLoading(true);
//     const payload = {
//       verification_id,
//       type: 'onboarding',
//     };

//     console.log('Creating DigiLocker URL with verification_id:', verification_id);

//     postRequest(CREATE_DIGILOCKER_URL, payload, history)
//       .then((response) => {
//         console.log('DigiLocker URL Response:', response);
//         if (response.success === true && response.data) {
//           // Store both in state and refs
//           setVerificationId(response.data.verification_id);
//           setReferenceId(response.data.reference_id);
//           verificationIdRef.current = response.data.verification_id;
//           referenceIdRef.current = response.data.reference_id;

//           console.log('Opening DigiLocker URL with stored Aadhaar:', aadharNumber);

//           if (response.data.url) {
//             window.open(response.data.url, '_blank', 'noopener,noreferrer');
//           }
//         } else {
//           toast.error(response.message || 'Failed to create DigiLocker URL');
//         }
//       })
//       .catch((error) => {
//         console.error('DigiLocker Error:', error);
//         toast.error('Failed to initiate DigiLocker verification');
//       })
//       .finally(() => setLoading(false));
//   };

//   const getDocumentData = async (vid, refId, documentType) => {
//     if (!vid) return;

//     try {
//       setLoading(true);
//       const payload = {
//         verificationId: vid,
//         referenceId: refId,
//         documentType: documentType,
//       };

//       console.log(`Getting ${documentType} data with Aadhaar:`, aadharNumber, 'PAN:', pancardNumber);

//       const res = await postRequest(GET_DOCUMENT_DATA, payload, history);
//       if (res && res.success) {
//         if (documentType === 'AADHAAR') {
//           if (res.data && res.data.uid) {
//             // Use the stored Aadhaar number from state




//             const enteredAadhaar = aadharNumber;
//             const maskedAadhaar = res?.data?.uid?.trim() || '';

//             // console.log('Aadhaar Validation - Stored:', enteredAadhaar, 'From API:', maskedAadhaar);

//             if (!enteredAadhaar) {
//               toast.error('Aadhaar number is missing for validation. Please re-enter the Aadhaar number.');
//               return;
//             }

//             const aadhaarRegex = /^\d{12}$/;
//             if (!aadhaarRegex.test(enteredAadhaar)) {
//               toast.error('Please enter a valid 12-digit Aadhaar Number');
//               return;
//             }

//             const maskedLast4 = maskedAadhaar.slice(-4);
//             const enteredLast4 = enteredAadhaar.slice(-4);

//             console.log('Aadhaar Last 4 comparison - Entered:', enteredLast4, 'API:', maskedLast4);

//             if (maskedLast4 !== enteredLast4) {
//               toast.error('Aadhaar number does not match the provided record');
//               clearFormField();
//               return;
//             }

//             setAadharNumberVerify(true);
//             setAadharData(res.data);
//             setFirstName(res.data.name || '');

//             // Move to PAN verification
//             getDocumentData(vid, refId, 'PAN');
//           } else {
//             toast.error('Aadhaar data not found in DigiLocker response');
//           }
//         }

//         if (documentType === 'PAN') {
//           if (res.data && res.data.pan) {
//             // Use the stored PAN number from state
//             const enteredPAN = pancardNumber;
//             const serverPAN = res?.data?.pan?.trim().toUpperCase() || '';

//             console.log('PAN Validation - Stored:', enteredPAN, 'From API:', serverPAN);

//             const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
//             if (!panRegex.test(enteredPAN)) {
//               toast.error('Please enter a valid PAN Number (e.g., ABCDE1234F)');
//               return;
//             }

//             if (serverPAN && enteredPAN !== serverPAN) {
//               toast.error('PAN number does not match the provided record');
//               clearFormField();
//               return;
//             }

//             setPanNumberVerify(true);
//             setPancardData(res.data);

//             const name = res.data?.name_pan_card || res.data?.name || '';
//             const parts = name.trim().split(/\s+/).filter(Boolean);
//             setFullName(name);
//             setFirstName(parts[0] || '');
//             setLastName(parts.slice(1).join(' ') || '');

//             // Clear verification IDs
//             verificationIdRef.current = null;
//             referenceIdRef.current = null;
//             setVerificationId(null);
//             setReferenceId(null);

//             toast.success('Documents verified successfully! Please proceed to submit.');
//           } else {
//             toast.error('PAN data not found in DigiLocker response');
//           }
//         }
//       } else {
//         toast.error(res?.message || 'Document verification failed');
//       }
//     } catch (err) {
//       console.error('Error checking DigiLocker docs:', err);
//       toast.error('Error verifying documents');
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleVerifyPancardNumber = async () => {
//     const pancard = isData.pan_num;
//     if (!VerifyPanNumber(pancard)) return;

//     setLoading(true);
//     const payload = { pancard, roleId: isData.userRole };
//     postRequest(`${CREATE_USER_PANCARD_VERIFY}`, payload, history)
//       .then((response) => {
//         if (response.success) {
//           setPanNumberVerify(true);
//           setPancardData(response.data);

//           const name = response.data?.registered_name || response.data?.name || '';
//           const parts = name.trim().split(/\s+/).filter(Boolean);
//           setFullName(name);
//           setFirstName(parts[0] || '');
//           setLastName(parts.slice(1).join(' ') || '');

//           toast.success(response.message || 'PAN verified');
//         } else {
//           toast.error(response.message || 'PAN verification failed');
//         }
//       })
//       .catch((error) => {
//         console.error('PAN verify error', error);
//         toast.error('PAN verification failed');
//       })
//       .finally(() => setLoading(false));
//   };

//   const handleVerifyAadharNumber = async () => {
//     if (!isData.aadhar_num) {
//       toast.error('Aadhar is required');
//       return;
//     }

//     setLoading(true);
//     const payload = {
//       aadharcard: isData.aadhar_num,
//       roleId: isData.userRole,
//       name: fullName,
//     };
//     postRequest(`${CREATE_USER_AADHARCARD_VERIFY}`, payload, history)
//       .then((response) => {
//         if (response.success) {
//           setOtpAadharNumber(true);
//           setAadharData(response.data);
//           if (response.alreadysuccess) setAadharNumberVerify(true);

//           toast[response.alreadysuccess ? 'success' : 'warning'](response.message || 'Aadhar response');
//         } else {
//           toast.error(response.message || 'Aadhar verification failed');
//         }
//       })
//       .catch((error) => {
//         console.error('Aadhar verify error', error);
//         toast.error('Aadhar verification failed');
//       })
//       .finally(() => setLoading(false));
//   };

//   const handleVerifyOtpAadharNumber = () => {
//     setLoading(true);
//     const payload = {
//       aadharcard: isData.aadhar_num,
//       aadharcardOtp: isData.OtpAadharNumber,
//       ref_id: aadharData && aadharData.ref_id,
//     };
//     postRequest(CREATE_USER_AADHARCARD_OTP_VERIFY, payload, history)
//       .then((response) => {
//         if (response.success === true) {
//           setOtpAadharNumber(false);
//           setAadharNumberVerify(true);
//           setAadharData(response.data);
//           toast.success(response.message);
//         } else {
//           toast.error(response.message || 'Aadhar OTP verification failed');
//         }
//       })
//       .catch((error) => {
//         console.error('Aadhar OTP error', error);
//         toast.error('Aadhar OTP verification failed');
//       })
//       .finally(() => setLoading(false));
//   };

//   const handleSubmit = async () => {
//     const payload = {
//       pancard: pancardNumber,
//       firstName,
//       lastName,
//       mobile: isData.mobileNumber,
//       roleCode: roleId,
//       userRole: isData.userRole,
//       isStaff,
//       email: isData.email,
//       outletName: isData.outletName,
//       pancardData,
//       aadharcard: aadharNumber,
//       aadharNumberVerify: isAadharNumberVerify,
//       aadharData,
//     };

//     console.log('Submitting with Aadhaar:', aadharNumber, 'PAN:', pancardNumber);

//     postRequest(`${CREATE_ALL_TYPE_USERS}`, payload, history)
//       .then((response) => {
//         if (response.success) {
//           setShowingSubmitPopup(true);
//           setUsername(response.data.username);
//           setPassword(response.data.password);

//           // Reset everything
//           clearFormField();
//           toast.success(response.message);
//         } else {
//           toast.error(response.message || 'User creation failed');
//         }
//       })
//       .catch((error) => {
//         console.error('Create user error', error);
//         toast.error('User creation failed');
//       });
//   };

//   const handleCancelPopup = () => {
//     setShowingSubmitPopup(false);
//     setUsername('');
//     setPassword('');
//   };

//   const onChangeValue = (event) => {
//     const { name, value } = event.target;
//     if (name === 'pan_num') {
//       setData({ ...isData, [name]: value.toUpperCase() });
//     } else {
//       setData({ ...isData, [name]: value });
//     }
//   };

//   const onChangeUserRoleValue = (event) => {
//     const { value } = event || {};
//     setData({ ...isData, userRole: value, roleDataValue: event });
//   };

//   // Run once on mount: load roles and initial values
//   useEffect(() => {
//     handleGetRoles();
//     setRoleId(userData?.data?.role?.code);
//     setStaff(userData?.data?.isStaff || false);
//     setUserOrder(userData?.data?.role?.order);
//   }, []);

//   // Keep the ref in sync whenever verificationId changes
//   useEffect(() => {
//     verificationIdRef.current = verificationId;
//   }, [verificationId]);

//   // Attach focus listener for DigiLocker callback
//   useEffect(() => {
//     const handleFocus = async () => {
//       const vid = verificationIdRef.current;
//       const refId = referenceIdRef.current;

//       if (!vid) {
//         console.log('No verification ID found for DigiLocker callback');
//         return;
//       }

//       console.log('Window focus detected, checking DigiLocker status with VID:', vid, 'Aadhaar:', aadharNumber);

//       try {
//         setLoading(true);
//         const payload = {
//           verificationId: vid,
//           referenceId: refId,
//         };

//         const res = await postRequest(GET_VERIFICATION_STATUS, payload, history);
//         console.log('DigiLocker Status Response:', res);

//         if (res && res.success) {
//           await getDocumentData(vid, refId, 'AADHAAR');
//         } else {
//           toast.error(res?.message || 'Document verification failed');
//         }
//       } catch (err) {
//         console.error('Error checking DigiLocker docs:', err);
//         toast.error('Error verifying documents');
//       } finally {
//         setLoading(false);
//       }
//     };

//     window.addEventListener('focus', handleFocus);
//     return () => {
//       window.removeEventListener('focus', handleFocus);
//     };
//   }, [history, aadharNumber, pancardNumber]);

//   if (isLoading) {
//     return (
//       <div className="content text-center" style={{ margin: '250px 0' }}>
//         <RiseLoader color="#5851D2" loading={isLoading} size={25} />
//       </div>
//     );
//   }

//   return (
//     <div>
//       <div className="content-wrapper pt-2">
//         <div className="content-header">
//           <div className="container-fluid">
//             <div className="row mb-0 align-items-center">
//               <div className="col-sm-6">
//                 <h1 className="page-title text-blue font-merriweather">
//                   Create <span className="text-red"> Users</span>
//                 </h1>
//               </div>
//             </div>
//           </div>
//         </div>
//         <div className="content">
//           <div className="container-fluid pt-2 pb-5">
//             <div className="row">
//               <div className="col-md-6">
//                 <div className="card rounded-0">
//                   <div className="card-body">
//                     <div className="form-group">
//                       <label>Select Role</label>
//                       <div className="input-group">
//                         <Select
//                           options={getRoleData}
//                           className={`normal-light w-100`}
//                           classNamePrefix="select"
//                           placeholder="Select Role"
//                           value={isData.roleDataValue}
//                           name="userRole"
//                           onChange={(e) => onChangeUserRoleValue(e)}
//                         />
//                       </div>
//                     </div>

//                     <div className="form-group">
//                       <label>Outlet Name</label>
//                       <div className="input-group">
//                         <div className="custom-file">
//                           <input
//                             type="text"
//                             className="form-control"
//                             name="outletName"
//                             placeholder="Outlet Name"
//                             onChange={(e) => onChangeValue(e)}
//                             readOnly={isOutletNameSubmit}
//                             autoComplete="off"
//                             value={isData.outletName || ''}
//                           />
//                         </div>
//                       </div>
//                     </div>

//                     <div className="form-group">
//                       <label>Email Address</label>
//                       <div className="input-group">
//                         <div className="custom-file">
//                           <input
//                             type="text"
//                             className="form-control"
//                             name="email"
//                             placeholder="Email Address"
//                             onChange={(e) => onChangeValue(e)}
//                             autoComplete="off"
//                             readOnly={isEmailAddressSubmit}
//                             value={isData.email || ''}
//                           />
//                         </div>
//                       </div>
//                     </div>


//                     <div className="form-group">
//                       <label>Referral Mobile Number(Optional)</label>
//                       <div className="input-group">
//                         <div className="custom-file">
//                           <input
//                             type="text"
//                             className="form-control"
//                             name="email"
//                             placeholder="Email Address"
//                             onChange={(e) => onChangeValue(e)}
//                             autoComplete="off"
//                             readOnly={isEmailAddressSubmit}
//                             value={isData.email || ''}
//                           />
//                         </div>
//                       </div>
//                     </div>



//                     <div className="form-group">
//                       <label>Aadhar Number</label>
//                       <div className="input-group">
//                         <div className="custom-file">
//                           <input
//                             type="text"
//                             className="form-control"
//                             name="aadhar_num"
//                             placeholder="Aadhar Number"
//                             onChange={(e) => onChangeValue(e)}
//                             onKeyDown={isNumber}
//                             maxLength={12}
//                             autoComplete="off"
//                             value={isData.aadhar_num || ''}
//                           />
//                         </div>
//                       </div>
//                     </div>

//                     <div className="form-group">
//                       <label>PAN Number</label>
//                       <div className="input-group">
//                         <div className="custom-file">
//                           <input
//                             type="text"
//                             className="form-control"
//                             name="pan_num"
//                             placeholder="PAN Number"
//                             onChange={(e) => onChangeValue(e)}
//                             autoComplete="off"
//                             value={isData.pan_num || ''}
//                           />
//                         </div>
//                       </div>
//                     </div>

//                     <div className="form-group">
//                       <label>Mobile Number</label>
//                       <div className="input-group">
//                         <div className="custom-file">
//                           <input
//                             type="text"
//                             className="form-control"
//                             name="mobileNumber"
//                             placeholder="Mobile Number"
//                             onChange={(e) => onChangeValue(e)}
//                             autoComplete="off"
//                             maxLength={10}
//                             readOnly={isOtpNumber}
//                             onKeyDown={isNumber}
//                             value={isData.mobileNumber || ''}
//                           />
//                         </div>
//                         {!isMobileNumberVerify && !isOtpNumber && (
//                           <div className="input-group-append uploadbtn cursor-pointer" onClick={() => handleVerifyMobileNumber()}>
//                             <span className="input-group-text">Verify</span>
//                           </div>
//                         )}
//                       </div>
//                     </div>

//                     {isOtpNumber && !isMobileNumberVerify && (
//                       <div className="form-group">
//                         <label>OTP Number</label>
//                         <div className="input-group">
//                           <div className="custom-file">
//                             <input
//                               type="text"
//                               className="form-control"
//                               name="OtpNumber"
//                               placeholder="OTP Number"
//                               onChange={(e) => onChangeValue(e)}
//                               autoComplete="off"
//                               maxLength={4}
//                               onKeyDown={isNumber}
//                               value={isData.OtpNumber || ''}
//                             />
//                           </div>
//                           <div className="input-group-append uploadbtn cursor-pointer" onClick={() => handleVerifyOtpMobileNumber()}>
//                             <span className="input-group-text">Verify</span>
//                           </div>
//                         </div>
//                       </div>
//                     )}

//                     {isPanNumberVerify && isMobileNumberVerify && isAadharNumberVerify && (
//                       <div className="form-group">
//                         <div className="text-right">
//                           <Button type="default" onClick={() => handleSubmit()} className="col-lg-3 ml-2">
//                             Submit
//                           </Button>
//                         </div>
//                       </div>
//                     )}
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>

//         {showingSubmitPopup && (
//           <Modal open={showingSubmitPopup} footer={false} onCancel={handleCancelPopup}>
//             <div className="font-weight-bold text-center text-danger">
//               <div className="your-registration-is-successfull mt-3">
//                 <p className="msg1">Your Registration is successful. Please login using</p>
//                 <p className="user-id-xxxxx-one-time-pas">
//                   Username - <span className="xxxxx-span">{username}</span> &amp; Password - <span className="xxxxx-span">{password}</span>
//                 </p>
//               </div>
//             </div>
//           </Modal>
//         )}

//         <ToastContainer position="top-center" autoClose={5000} limit={2} hideProgressBar={false} newestOnTop={false} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover theme="colored" />
//       </div>
//     </div>
//   );
// }

// export default CreateUser;


import React, { useEffect, useState, useRef } from 'react';
import { Button, Modal } from 'antd';
import {
  CREATE_USER_PANCARD_VERIFY,
  MOBILE_SEND_VERFIY,
  MOBILE_VERFIY_SEND,
  USER_ROLE,
  CREATE_ALL_TYPE_USERS,
  CREATE_USER_AADHARCARD_VERIFY,
  CREATE_USER_AADHARCARD_OTP_VERIFY,
  DIGILOCKER_VERIFY,
  CREATE_DIGILOCKER_URL,
  GET_VERIFICATION_STATUS,
  GET_DOCUMENT_DATA,
} from './../../Utils/appConstants';
import { getRequest, postRequest } from './../../Utils/AppApi';
import { getUser, isNumber } from './../../Utils/Common';
import { useHistory } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import RiseLoader from 'react-spinners/RiseLoader';
import Select from 'react-select';

const userData = getUser();

function CreateUser(props) {
  // refs for plain inputs only
  const mobileNumberRef = useRef(null);
  const otpNumberRef = useRef(null);
  const otpAadharNumberRef = useRef(null);
  const outletNameRef = useRef(null);
  const emailRef = useRef(null);
  const pancardNumberRef = useRef(null);
  const aadharNumberRef = useRef(null);
  const referralMobileRef = useRef(null); // NEW: ref for referral mobile

  const history = useHistory();

  // Form data state
  const [isData, setData] = useState({
    userRole: '',
    outletName: '',
    email: '',
    aadhar_num: '',
    pan_num: '',
    mobileNumber: '',
    OtpNumber: '',
    OtpAadharNumber: '',
    referralMobile: '' // NEW: referral mobile field
  });

  const [fullName, setFullName] = useState('');
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [pancardData, setPancardData] = useState('');
  const [isOtpNumber, setOtpNumber] = useState(false);
  const [roleId, setRoleId] = useState(userData?.data?.role?.code);
  const [userOrder, setUserOrder] = useState(userData?.data?.role?.order);
  const [isMobileNumberVerify, setMobileNumberVerify] = useState(false);
  const [isPanNumberVerify, setPanNumberVerify] = useState(false);
  const [isStaff, setStaff] = useState(false);
  const [isLoading, setLoading] = useState(false);
  const [showingSubmitPopup, setShowingSubmitPopup] = useState(false);

  const [getRoleData, setRoleData] = useState([]);

  const [isAadharNumberVerify, setAadharNumberVerify] = useState(false);
  const [aadharData, setAadharData] = useState('');
  const [isOtpAadharNumber, setOtpAadharNumber] = useState(false);

  const [isOutletNameSubmit, setOutletNameSubmit] = useState(false);
  const [isEmailAddressSubmit, setEmailAddressSubmit] = useState(false);
  const [verificationId, setVerificationId] = useState(null);
  const [referenceId, setReferenceId] = useState(null);

  // Store the actual values that will be used in verification
  const [pancardNumber, setPancardNumber] = useState('');
  const [aadharNumber, setAadharNumber] = useState('');

  const verificationIdRef = useRef(null);
  const referenceIdRef = useRef(null);

  // NEW: Validation function for referral mobile number
  const validateReferralMobile = (mobile) => {
    if (!mobile || mobile.trim() === '') {
      return true; // Optional field, empty is valid
    }
    const mobileRegex = /^[6-9][0-9]{9}$/;
    return mobileRegex.test(mobile.trim());
  };

  const clearFormField = () => {
    // Reset all form state
    setData({
      userRole: '',
      outletName: '',
      email: '',
      aadhar_num: '',
      pan_num: '',
      mobileNumber: '',
      OtpNumber: '',
      OtpAadharNumber: '',
      referralMobile: '' // NEW: reset referral mobile
    });
    setAadharNumber('');
    setPancardNumber('');
    setFullName('');
    setFirstName('');
    setLastName('');
    setPancardData('');
    setAadharData('');
    setOtpNumber(false);
    setMobileNumberVerify(false);
    setPanNumberVerify(false);
    setAadharNumberVerify(false);
    setOtpAadharNumber(false);
    setOutletNameSubmit(false);
    setEmailAddressSubmit(false);

    verificationIdRef.current = null;
    referenceIdRef.current = null;
    setVerificationId(null);
    setReferenceId(null);

    // Clear refs
    if (mobileNumberRef.current) mobileNumberRef.current.value = '';
    if (otpNumberRef.current) otpNumberRef.current.value = '';
    if (otpAadharNumberRef.current) otpAadharNumberRef.current.value = '';
    if (outletNameRef.current) outletNameRef.current.value = '';
    if (emailRef.current) emailRef.current.value = '';
    if (pancardNumberRef.current) pancardNumberRef.current.value = '';
    if (aadharNumberRef.current) aadharNumberRef.current.value = '';
    if (referralMobileRef.current) referralMobileRef.current.value = ''; // NEW: clear referral mobile ref
  };

  const handleGetRoles = () => {
    const userOrderId = userData?.data?.role?.order;
    getRequest(`${USER_ROLE}/${userOrderId}`, history)
      .then((response) => {
        if (response.success === true && Array.isArray(response.data)) {
          setRoleData(
            response.data
              .filter((items) => items.code !== 'V')
              .map((item) => ({ value: item.code, label: item.name }))
          );
        } else {
          toast.error(response.message || 'Failed to load roles');
        }
      })
      .catch((error) => {
        console.error('Error loading roles', error);
        toast.error('Failed to load roles');
      });
  };

  const FormValidate = () => {
    // basic validation - ensure role present for the specific user orders
    if ([5, 4, 2].includes(userOrder)) {
      if (!isData || Object.keys(isData).length === 0) {
        toast.error('Role is required');
        return false;
      }
      if (!isData.userRole) {
        toast.error('Role is required');
        return false;
      }
    }

    return true;
  };

  const handleVerifyMobileNumber = () => {
    if (!FormValidate()) return;

    if (!isData.outletName || isData.outletName.trim() === '') {
      toast.error('Please enter Outlet Name');
      return;
    }

    if (!isData.email || isData.email.trim() === '') {
      toast.error('Please enter Email Address');
      return;
    }

    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailPattern.test(isData.email)) {
      toast.error('Please enter a valid Email Address');
      return;
    }

    if (!isData.aadhar_num || isData.aadhar_num.trim() === '') {
      toast.error('Please enter Aadhaar Number');
      return;
    }

    const aadhaarRegex = /^\d{12}$/;
    if (!aadhaarRegex.test(isData.aadhar_num.trim())) {
      toast.error('Please enter a valid 12-digit Aadhaar Number');
      return;
    }

    if (!isData.pan_num || isData.pan_num.trim() === '') {
      toast.error('Please enter PAN Number');
      return;
    }

    const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
    if (!panRegex.test(isData.pan_num.trim().toUpperCase())) {
      toast.error('Please enter a valid PAN Number (e.g., ABCDE1234F)');
      return;
    }

    if (!isData.mobileNumber || !/^\d{10}$/.test(isData.mobileNumber)) {
      toast.error('Please enter a valid 10-digit mobile number');
      return;
    }

    // NEW: Validate referral mobile number if provided
    if (isData.referralMobile && isData.referralMobile.trim() !== '') {
      if (!validateReferralMobile(isData.referralMobile)) {
        toast.error('Referral mobile number must be a valid 10-digit number starting with 6, 7, 8, or 9');
        return;
      }
    }

    setLoading(true);
    
    const payload = {
      mobile: isData.mobileNumber,
      roleId: isData.userRole,
      panNumber: isData.pan_num.trim().toUpperCase()
    };

    // CRITICAL: Store the values in dedicated state before proceeding
    setAadharNumber(isData.aadhar_num.trim());
    setPancardNumber(isData.pan_num.trim().toUpperCase());

    console.log('Storing Aadhaar for verification:', isData.aadhar_num.trim());

    postRequest(MOBILE_VERFIY_SEND, payload, history)
      .then((response) => {
        if (response.success === true) {
          toast.success(response.message);
          setOtpNumber(true);
        } else {
          toast.error(response.message || 'Failed to send OTP');
        }
      })
      .catch((error) => {
        console.error('send mobile verify error', error);
        toast.error('Failed to send OTP');
      })
      .finally(() => setLoading(false));
  };

  const handleVerifyOtpMobileNumber = () => {
    if (!isData.mobileNumber || !isData.OtpNumber) {
      toast.error('Mobile and OTP are required');
      return;
    }

    // Use the stored Aadhaar number from state
    if (!aadharNumber) {
      toast.error('Aadhaar number is required for verification');
      return;
    }

    console.log('Starting OTP verification with Aadhaar:', aadharNumber);

    setLoading(true);
    const payload = {
      mobile: isData.mobileNumber,
      otp: isData.OtpNumber,
    };

    postRequest(MOBILE_SEND_VERFIY, payload, history)
      .then((response) => {
        if (response.success === true) {
          toast.success(response.message);
          setOtpNumber(false);
          setMobileNumberVerify(true);
          setOutletNameSubmit(true);
          setEmailAddressSubmit(true);

          // Start digilocker flow with the stored Aadhaar number
          initiateDigilocker(isData.mobileNumber);
        } else {
          toast.error(response.message || 'OTP verification failed');
        }
      })
      .catch((error) => {
        console.error('OTP verify error', error);
        toast.error('OTP verification failed');
      })
      .finally(() => setLoading(false));
  };

  const pancardValidation = (text) => {
    if (!text) return false;
    const regex = /^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/;
    return regex.test(text.trim());
  };

  const VerifyPanNumber = (pancard) => {
    if (!pancard) {
      toast.error('Pancard is required');
      return false;
    }
    const pc = pancard.toUpperCase().trim();
    if (pancardValidation(pc)) {
      return true;
    }
    toast.error('Pancard number is invalid');
    return false;
  };

  const initiateDigilocker = (mobileNumber) => {
    if (!FormValidate()) {
      toast.error('Form validation failed');
      return;
    }

    if (!mobileNumber || !/^\d{10}$/.test(mobileNumber)) {
      toast.error('Please provide a valid 10-digit mobile number');
      return;
    }

    setLoading(true);
    const payload = {
      mobile: mobileNumber,
      type: 'onboarding',
    };

    console.log('Initiating DigiLocker with mobile:', mobileNumber);

    postRequest(DIGILOCKER_VERIFY, payload, history)
      .then((response) => {
        console.log('DigiLocker Response:', response);
        if (response.success === true) {
          const verification_id = response.data?.verification_id;
          if (verification_id) {
            createDigilockerURL(verification_id);
          } else {
            toast.error('Missing verification id from DigiLocker response');
          }
        } else {
          toast.error(response.message || 'Failed to initiate DigiLocker');
        }
      })
      .catch((error) => {
        console.error('DigiLocker Error:', error);
        toast.error('Failed to initiate DigiLocker verification');
      })
      .finally(() => setLoading(false));
  };

  const createDigilockerURL = (verification_id) => {
    if (!FormValidate()) {
      toast.error('Form validation failed');
      return;
    }

    setLoading(true);
    const payload = {
      verification_id,
      type: 'onboarding',
    };

    console.log('Creating DigiLocker URL with verification_id:', verification_id);

    postRequest(CREATE_DIGILOCKER_URL, payload, history)
      .then((response) => {
        console.log('DigiLocker URL Response:', response);
        if (response.success === true && response.data) {
          // Store both in state and refs
          setVerificationId(response.data.verification_id);
          setReferenceId(response.data.reference_id);
          verificationIdRef.current = response.data.verification_id;
          referenceIdRef.current = response.data.reference_id;

          console.log('Opening DigiLocker URL with stored Aadhaar:', aadharNumber);

          if (response.data.url) {
            window.open(response.data.url, '_blank', 'noopener,noreferrer');
          }
        } else {
          toast.error(response.message || 'Failed to create DigiLocker URL');
        }
      })
      .catch((error) => {
        console.error('DigiLocker Error:', error);
        toast.error('Failed to initiate DigiLocker verification');
      })
      .finally(() => setLoading(false));
  };

  const getDocumentData = async (vid, refId, documentType) => {
    if (!vid) return;

    try {
      setLoading(true);
      const payload = {
        verificationId: vid,
        referenceId: refId,
        documentType: documentType,
      };

      console.log(`Getting ${documentType} data with Aadhaar:`, aadharNumber, 'PAN:', pancardNumber);

      const res = await postRequest(GET_DOCUMENT_DATA, payload, history);
      if (res && res.success) {
        if (documentType === 'AADHAAR') {
          if (res.data && res.data.uid) {
            // Use the stored Aadhaar number from state
            const enteredAadhaar = aadharNumber;
            const maskedAadhaar = res?.data?.uid?.trim() || '';

            if (!enteredAadhaar) {
              toast.error('Aadhaar number is missing for validation. Please re-enter the Aadhaar number.');
              return;
            }

            const aadhaarRegex = /^\d{12}$/;
            if (!aadhaarRegex.test(enteredAadhaar)) {
              toast.error('Please enter a valid 12-digit Aadhaar Number');
              return;
            }

            const maskedLast4 = maskedAadhaar.slice(-4);
            const enteredLast4 = enteredAadhaar.slice(-4);

            console.log('Aadhaar Last 4 comparison - Entered:', enteredLast4, 'API:', maskedLast4);

            if (maskedLast4 !== enteredLast4) {
              toast.error('Aadhaar number does not match the provided record');
              clearFormField();
              return;
            }

            setAadharNumberVerify(true);
            setAadharData(res.data);
            setFirstName(res.data.name || '');

            // Move to PAN verification
            getDocumentData(vid, refId, 'PAN');
          } else {
            toast.error('Aadhaar data not found in DigiLocker response');
          }
        }

        if (documentType === 'PAN') {
          if (res.data && res.data.pan) {
            // Use the stored PAN number from state
            const enteredPAN = pancardNumber;
            const serverPAN = res?.data?.pan?.trim().toUpperCase() || '';

            console.log('PAN Validation - Stored:', enteredPAN, 'From API:', serverPAN);

            const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
            if (!panRegex.test(enteredPAN)) {
              toast.error('Please enter a valid PAN Number (e.g., ABCDE1234F)');
              return;
            }

            if (serverPAN && enteredPAN !== serverPAN) {
              toast.error('PAN number does not match the provided record');
              clearFormField();
              return;
            }

            setPanNumberVerify(true);
            setPancardData(res.data);

            const name = res.data?.name_pan_card || res.data?.name || '';
            const parts = name.trim().split(/\s+/).filter(Boolean);
            setFullName(name);
            setFirstName(parts[0] || '');
            setLastName(parts.slice(1).join(' ') || '');

            // Clear verification IDs
            verificationIdRef.current = null;
            referenceIdRef.current = null;
            setVerificationId(null);
            setReferenceId(null);

            toast.success('Documents verified successfully! Please proceed to submit.');
          } else {
            toast.error('PAN data not found in DigiLocker response');
          }
        }
      } else {
        toast.error(res?.message || 'Document verification failed');
      }
    } catch (err) {
      console.error('Error checking DigiLocker docs:', err);
      toast.error('Error verifying documents');
    } finally {
      setLoading(false);
    }
  };

  const handleVerifyPancardNumber = async () => {
    const pancard = isData.pan_num;
    if (!VerifyPanNumber(pancard)) return;

    setLoading(true);
    const payload = { pancard, roleId: isData.userRole };
    postRequest(`${CREATE_USER_PANCARD_VERIFY}`, payload, history)
      .then((response) => {
        if (response.success) {
          setPanNumberVerify(true);
          setPancardData(response.data);

          const name = response.data?.registered_name || response.data?.name || '';
          const parts = name.trim().split(/\s+/).filter(Boolean);
          setFullName(name);
          setFirstName(parts[0] || '');
          setLastName(parts.slice(1).join(' ') || '');

          toast.success(response.message || 'PAN verified');
        } else {
          toast.error(response.message || 'PAN verification failed');
        }
      })
      .catch((error) => {
        console.error('PAN verify error', error);
        toast.error('PAN verification failed');
      })
      .finally(() => setLoading(false));
  };

  const handleVerifyAadharNumber = async () => {
    if (!isData.aadhar_num) {
      toast.error('Aadhar is required');
      return;
    }

    setLoading(true);
    const payload = {
      aadharcard: isData.aadhar_num,
      roleId: isData.userRole,
      name: fullName,
    };
    postRequest(`${CREATE_USER_AADHARCARD_VERIFY}`, payload, history)
      .then((response) => {
        if (response.success) {
          setOtpAadharNumber(true);
          setAadharData(response.data);
          if (response.alreadysuccess) setAadharNumberVerify(true);

          toast[response.alreadysuccess ? 'success' : 'warning'](response.message || 'Aadhar response');
        } else {
          toast.error(response.message || 'Aadhar verification failed');
        }
      })
      .catch((error) => {
        console.error('Aadhar verify error', error);
        toast.error('Aadhar verification failed');
      })
      .finally(() => setLoading(false));
  };

  const handleVerifyOtpAadharNumber = () => {
    setLoading(true);
    const payload = {
      aadharcard: isData.aadhar_num,
      aadharcardOtp: isData.OtpAadharNumber,
      ref_id: aadharData && aadharData.ref_id,
    };
    postRequest(CREATE_USER_AADHARCARD_OTP_VERIFY, payload, history)
      .then((response) => {
        if (response.success === true) {
          setOtpAadharNumber(false);
          setAadharNumberVerify(true);
          setAadharData(response.data);
          toast.success(response.message);
        } else {
          toast.error(response.message || 'Aadhar OTP verification failed');
        }
      })
      .catch((error) => {
        console.error('Aadhar OTP error', error);
        toast.error('Aadhar OTP verification failed');
      })
      .finally(() => setLoading(false));
  };

  const handleSubmit = async () => {
    // NEW: Final validation for referral mobile number before submission
    if (isData.referralMobile && isData.referralMobile.trim() !== '') {
      if (!validateReferralMobile(isData.referralMobile)) {
        toast.error('Referral mobile number must be a valid 10-digit number starting with 6, 7, 8, or 9');
        return;
      }
    }

    const payload = {
      pancard: pancardNumber,
      firstName,
      lastName,
      mobile: isData.mobileNumber,
      roleCode: roleId,
      userRole: isData.userRole,
      isStaff,
      email: isData.email,
      outletName: isData.outletName,
      pancardData,
      aadharcard: aadharNumber,
      aadharNumberVerify: isAadharNumberVerify,
      aadharData,
      referralMobileNumber: isData.referralMobile || '', // NEW: Add referral mobile number
    };

    console.log('Submitting with Aadhaar:', aadharNumber, 'PAN:', pancardNumber, 'Referral Mobile:', isData.referralMobile);

    postRequest(`${CREATE_ALL_TYPE_USERS}`, payload, history)
      .then((response) => {
        if (response.success) {
          setShowingSubmitPopup(true);
          setUsername(response.data.username);
          setPassword(response.data.password);

          // Reset everything
          clearFormField();
          toast.success(response.message);
        } else {
          toast.error(response.message || 'User creation failed');
        }
      })
      .catch((error) => {
        console.error('Create user error', error);
        toast.error('User creation failed');
      });
  };

  const handleCancelPopup = () => {
    setShowingSubmitPopup(false);
    setUsername('');
    setPassword('');
  };

  const onChangeValue = (event) => {
    const { name, value } = event.target;
    if (name === 'pan_num') {
      setData({ ...isData, [name]: value.toUpperCase() });
    } else if (name === 'referralMobile') {
      // NEW: Only allow digits for referral mobile
      const digitsOnly = value.replace(/\D/g, '');
      if (digitsOnly.length <= 10) {
        setData({ ...isData, [name]: digitsOnly });
      }
    } else {
      setData({ ...isData, [name]: value });
    }
  };

  const onChangeUserRoleValue = (event) => {
    const { value } = event || {};
    setData({ ...isData, userRole: value, roleDataValue: event });
  };

  // Run once on mount: load roles and initial values
  useEffect(() => {
    handleGetRoles();
    setRoleId(userData?.data?.role?.code);
    setStaff(userData?.data?.isStaff || false);
    setUserOrder(userData?.data?.role?.order);
  }, []);

  // Keep the ref in sync whenever verificationId changes
  useEffect(() => {
    verificationIdRef.current = verificationId;
  }, [verificationId]);

  // Attach focus listener for DigiLocker callback
  useEffect(() => {
    const handleFocus = async () => {
      const vid = verificationIdRef.current;
      const refId = referenceIdRef.current;

      if (!vid) {
        console.log('No verification ID found for DigiLocker callback');
        return;
      }

      console.log('Window focus detected, checking DigiLocker status with VID:', vid, 'Aadhaar:', aadharNumber);

      try {
        setLoading(true);
        const payload = {
          verificationId: vid,
          referenceId: refId,
        };

        const res = await postRequest(GET_VERIFICATION_STATUS, payload, history);
        console.log('DigiLocker Status Response:', res);

        if (res && res.success) {
          await getDocumentData(vid, refId, 'AADHAAR');
        } else {
          toast.error(res?.message || 'Document verification failed');
        }
      } catch (err) {
        console.error('Error checking DigiLocker docs:', err);
        toast.error('Error verifying documents');
      } finally {
        setLoading(false);
      }
    };

    window.addEventListener('focus', handleFocus);
    return () => {
      window.removeEventListener('focus', handleFocus);
    };
  }, [history, aadharNumber, pancardNumber]);

  if (isLoading) {
    return (
      <div className="content text-center" style={{ margin: '250px 0' }}>
        <RiseLoader color="#5851D2" loading={isLoading} size={25} />
      </div>
    );
  }

  return (
    <div>
      <div className="content-wrapper pt-2">
        <div className="content-header">
          <div className="container-fluid">
            <div className="row mb-0 align-items-center">
              <div className="col-sm-6">
                <h1 className="page-title text-blue font-merriweather">
                  Create <span className="text-red"> Users</span>
                </h1>
              </div>
            </div>
          </div>
        </div>
        <div className="content">
          <div className="container-fluid pt-2 pb-5">
            <div className="row">
              <div className="col-md-6">
                <div className="card rounded-0">
                  <div className="card-body">
                    <div className="form-group">
                      <label>Select Role</label>
                      <div className="input-group">
                        <Select
                          options={getRoleData}
                          className={`normal-light w-100`}
                          classNamePrefix="select"
                          placeholder="Select Role"
                          value={isData.roleDataValue}
                          name="userRole"
                          onChange={(e) => onChangeUserRoleValue(e)}
                        />
                      </div>
                    </div>

                    <div className="form-group">
                      <label>Outlet Name</label>
                      <div className="input-group">
                        <div className="custom-file">
                          <input
                            type="text"
                            className="form-control"
                            name="outletName"
                            placeholder="Outlet Name"
                            onChange={(e) => onChangeValue(e)}
                            readOnly={isOutletNameSubmit}
                            autoComplete="off"
                            value={isData.outletName || ''}
                          />
                        </div>
                      </div>
                    </div>

                    <div className="form-group">
                      <label>Email Address</label>
                      <div className="input-group">
                        <div className="custom-file">
                          <input
                            type="text"
                            className="form-control"
                            name="email"
                            placeholder="Email Address"
                            onChange={(e) => onChangeValue(e)}
                            autoComplete="off"
                            readOnly={isEmailAddressSubmit}
                            value={isData.email || ''}
                          />
                        </div>
                      </div>
                    </div>

                    {/* NEW: Referral Mobile Number Field */}
                    <div className="form-group">
                      <label>Referral Mobile Number (Optional)</label>
                      <div className="input-group">
                        <div className="custom-file">
                          <input
                            type="text"
                            className="form-control"
                            name="referralMobile"
                            placeholder="Enter 10-digit mobile number"
                            onChange={(e) => onChangeValue(e)}
                            autoComplete="off"
                            maxLength={10}
                            value={isData.referralMobile || ''}
                          />
                        </div>
                      </div>
                      {/* <small className="text-muted">Must be a valid 10-digit number starting with 6, 7, 8, or 9 (Optional)</small> */}
                    </div>

                    <div className="form-group">
                      <label>Aadhar Number</label>
                      <div className="input-group">
                        <div className="custom-file">
                          <input
                            type="text"
                            className="form-control"
                            name="aadhar_num"
                            placeholder="Aadhar Number"
                            onChange={(e) => onChangeValue(e)}
                            onKeyDown={isNumber}
                            maxLength={12}
                            autoComplete="off"
                            value={isData.aadhar_num || ''}
                          />
                        </div>
                      </div>
                    </div>

                    <div className="form-group">
                      <label>PAN Number</label>
                      <div className="input-group">
                        <div className="custom-file">
                          <input
                            type="text"
                            className="form-control"
                            name="pan_num"
                            placeholder="PAN Number"
                            onChange={(e) => onChangeValue(e)}
                            autoComplete="off"
                            value={isData.pan_num || ''}
                          />
                        </div>
                      </div>
                    </div>

                    <div className="form-group">
                      <label>Mobile Number</label>
                      <div className="input-group">
                        <div className="custom-file">
                          <input
                            type="text"
                            className="form-control"
                            name="mobileNumber"
                            placeholder="Mobile Number"
                            onChange={(e) => onChangeValue(e)}
                            autoComplete="off"
                            maxLength={10}
                            readOnly={isOtpNumber}
                            onKeyDown={isNumber}
                            value={isData.mobileNumber || ''}
                          />
                        </div>
                        {!isMobileNumberVerify && !isOtpNumber && (
                          <div className="input-group-append uploadbtn cursor-pointer" onClick={() => handleVerifyMobileNumber()}>
                            <span className="input-group-text">Verify</span>
                          </div>
                        )}
                      </div>
                    </div>

                    {isOtpNumber && !isMobileNumberVerify && (
                      <div className="form-group">
                        <label>OTP Number</label>
                        <div className="input-group">
                          <div className="custom-file">
                            <input
                              type="text"
                              className="form-control"
                              name="OtpNumber"
                              placeholder="OTP Number"
                              onChange={(e) => onChangeValue(e)}
                              autoComplete="off"
                              maxLength={4}
                              onKeyDown={isNumber}
                              value={isData.OtpNumber || ''}
                            />
                          </div>
                          <div className="input-group-append uploadbtn cursor-pointer" onClick={() => handleVerifyOtpMobileNumber()}>
                            <span className="input-group-text">Verify</span>
                          </div>
                        </div>
                      </div>
                    )}

                    {isPanNumberVerify && isMobileNumberVerify && isAadharNumberVerify && (
                      <div className="form-group">
                        <div className="text-right">
                          <Button type="default" onClick={() => handleSubmit()} className="col-lg-3 ml-2">
                            Submit
                          </Button>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {showingSubmitPopup && (
          <Modal open={showingSubmitPopup} footer={false} onCancel={handleCancelPopup}>
            <div className="font-weight-bold text-center text-danger">
              <div className="your-registration-is-successfull mt-3">
                <p className="msg1">Your Registration is successful. Please login using</p>
                <p className="user-id-xxxxx-one-time-pas">
                  Username - <span className="xxxxx-span">{username}</span> &amp; Password - <span className="xxxxx-span">{password}</span>
                </p>
              </div>
            </div>
          </Modal>
        )}

        <ToastContainer position="top-center" autoClose={5000} limit={2} hideProgressBar={false} newestOnTop={false} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover theme="colored" />
      </div>
    </div>
  );
}

export default CreateUser;